import React from 'react';
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color';

import { store } from '../../../../store'

const initialState = {
    customization: store.getState().customization.custom,
    colorPicker: false,
    bgcolor: '',
    aboutColor: '',
    nameColor: '',
    bioColor: '',
    iconColor: '',
    selectProfile: '',
    bgOpacity: ''
}

class ColorPick extends React.Component {
	constructor(props) {
    super(props)
    this.state = initialState
}
componentDidMount() {
let { customization } = store.getState()
  this.setState({customization: customization.custom})
    customization.custom.map((value,i) => {
        switch(value.class) {
        case 'background':
          this.setState({
            bgColor: value.color,
            bgOpacity: value.opacity
          })
        break;
          case 'about':
          this.setState({
            aboutColor: value.color
          })
        break;
        case 'profile_name':
          this.setState({
            nameColor: value.color
          })
        break;
        case 'profile_bio':
          this.setState({
            bioColor: value.color
          })
        break;
        case 'about':
          this.setState({
            aboutColor: value.color
          })
        case 'icons':
        if(value.color === '#000')
          this.setState({
            iconColor: true
          })
        else
          this.setState({
            iconColor: false
          })
        break;
        default:
          this.setState({
            color: value.color
          })
      }
  })
}
  handlecolor = () => {
    this.setState({ colorPicker: !this.state.colorPicker })
}
	render() {
let { customization } = store.getState()
const handleChange = (color, opacity) => {
  let customizationElement = null

    let arr = this.state.customization;

        arr.map((value,i) => {
        if(customization.select === 'profile' && value.class === this.state.selectProfile) 
        {
          if(value.class === 'profile_name') 
          {
              this.setState({nameColor: color.hex})
              arr[i].color = color.hex 
          
          }
          else if(value.class === 'profile_bio') 
          {
              this.setState({bioColor: color.hex})
              arr[i].color = color.hex    
          }
          else if(value.class === 'icons') 
          {
              if(color.target.checked === true) {  
                this.setState({iconColor: true})
                arr[i].color = '#000' 
              } 
              else {
                this.setState({iconColor: false})
                arr[i].color = '#fff' 
              } 
          }
        }
        else if(value.class === customization.select)
        {
            if(value.class === 'background') {
              if(opacity === 'opacity') {
                if(color.target.value === '10')
                {
                  this.setState({bgOpacity: '1'})
                  arr[i].opacity = '1'
                }
                else
                {
                  this.setState({bgOpacity: '.' + color.target.value})
                  arr[i].opacity = '.' + color.target.value
                }
              }
              else {
                this.setState({bgColor: color.hex})
                arr[i].color = color.hex 
              }
            }
            if(value.class === 'about') {
              this.setState({aboutColor: color.hex})
              arr[i].color = color.hex 
            }       
        }
        })
    this.props.onCustomization(arr)
    this.setState({customization:arr})
}
const styles = reactCSS({
      'default': {
        popover: {
          position: 'absolute',
          animation: '.25s ease-in-out 0s 1 fadeIn',
          boxShadow: '0 0px 2px #fff',
          borderRadius: '5px',
          zIndex: 1,
          overflowX: 'visible'
        },
        cover: {
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
        nameColor: {
          width: '100%',
          height: '30px',
          borderRadius: '2px',
          background: `${this.state.nameColor}`,
        },
        bioColor: {
          width: '100%',
          height: '30px',
          borderRadius: '2px',
          background: `${this.state.bioColor}`,
        },
        bgColor: {
          width: '100%',
          height: '30px',
          borderRadius: '2px',
          background: `${this.state.bgColor}`,
        },
        aboutColor: {
          width: '100%',
          height: '30px',
          borderRadius: '2px',
          background: `${this.state.aboutColor}`,
        },
        swatch: {
          padding: '5px',
          background: '#001122',
          width: '100%',
          borderRadius: '2px',
          boxShadow: `0 0 1px #aaa`,
          cursor: 'pointer',
        },
      },
    })
  if(customization.select === 'profile')
  {
		return (<div>
      <div onClick={()=>this.setState({selectProfile: 'profile_name'})}>
          <span className="select_custom_label">Profile Name Color</span>
    <div handlecolor style={ styles.swatch } onClick={this.handlecolor}>
    <div style={ styles.nameColor } />
    </div>
    {this.state.colorPicker && this.state.selectProfile === 'profile_name'
    ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClick } />
            <SketchPicker triangle="hide" color={ this.state.nameColor } onChange={ handleChange } />
            </div>
    : null
    }
    </div>
    <div onClick={()=>this.setState({selectProfile: 'profile_bio'})}>
          <span className="select_custom_label">Profile Bio Color</span>
    <div handlecolor style={ styles.swatch } onClick={this.handlecolor}>
    <div style={ styles.bioColor } />
    </div>
    {this.state.colorPicker && this.state.selectProfile === 'profile_bio'
    ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClick } />
            <SketchPicker triangle="hide" color={ this.state.bioColor } onChange={ handleChange } />
            </div>
    : null
    }
    </div>
    <div className="select_custom" onMouseOver={()=>this.setState({selectProfile: 'icons'})}>
    <span className="select_custom_label">Icon Color Scheme</span>

        <div className="range_outside">
              <div className="toggle_btn">
              <input type="checkbox" id="switch" 
    defaultChecked={this.state.iconColor}
    onChange={handleChange} /><label for="switch">Toggle</label>
    <div className="color_dark_light">{this.state.iconColor ? 'Dark' : 'Light'}</div>
              </div>
        </div>
    </div>
    </div>)
  }
  if(customization.select === 'background')
  {
    return (<div>
      <div>
        <span className="select_custom_head">Background Color</span>
          <span className="select_custom_label">Pick a color</span>
    <div handlecolor style={ styles.swatch } onClick={this.handlecolor}>
    <div style={ styles.bgColor } />
    </div>
    {this.state.colorPicker
    ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClick } />
            <SketchPicker triangle="hide" color={ this.state.bgColor } onChange={ handleChange } />
            </div>
    : null
    }
    </div>
        <span className="select_custom_label">Background Image Opacity</span>

        <div className="range_outside">
    <input type="range" min="0" max="10" value="50" className="slider" id="myRange" 
    value={this.state.bgOpacity * 10}
    onChange={(e,check)=>handleChange(e,'opacity')} 
    selectedValue={this.state.bgOpacity} />
    <span className="range_output">{this.state.bgOpacity}</span>
    </div>

    </div>)
  }
  if(customization.select === 'about')
  {
    return (<div>
      <div>
          <span className="select_custom_label">Font Color</span>
    <div handlecolor style={ styles.swatch } onClick={this.handlecolor}>
    <div style={ styles.aboutColor } />
    </div>
    {this.state.colorPicker
    ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClick } />
            <SketchPicker triangle="hide" color={ this.state.aboutColor } onChange={ handleChange } />
            </div>
    : null
    }
    </div>
    </div>)
  }
  return null
}
}
export default ColorPick